export const ALL_NEW_SESSIONS = "ALL_NEW_SESSIONS";
export const ALL_SESSIONS_FAIL = "ALL_SESSIONS_FAIL";
export const ALL_SESSIONS = "ALL_SESSIONS";
export const UPDATE_SESSIONS = "UPDATE_SESSIONS";
export const LOAD_SESSION = "LOAD_SESSION";
